import {
  Components, ColorProfiles,
} from '@powdr/constants';

// Color Profiles
const {
  BASE, PRIMARY, SECONDARY, TERTIARY, QUATERNARY,
} = ColorProfiles;

export const config = {
  [Components.HEADER]: BASE,
  [Components.MAIN_NAV]: BASE,
  [Components.MEGA_NAV]: BASE,
  [Components.MOBILE_NAV]: BASE,
  [Components.ECOMMERCE_BANNER]: BASE,
  [Components.WEATHER_FEED]: PRIMARY,
  [Components.PROMOTIONS_FEED]: PRIMARY,
  [Components.PROMOTIONS]: BASE,
  [Components.ALERT_BAR]: BASE,
  [Components.STICKY_NAV]: PRIMARY,
  [Components.TERTIARY_NAV]: BASE,
  [Components.FOOTER]: TERTIARY,
  [Components.FOOTER_NAV]: PRIMARY,
  [Components.PARTNERS]: TERTIARY,
  [Components.COPYRIGHT]: PRIMARY,
  [Components.MODAL]: BASE,
  [Components.DOR]: BASE,
  layout: {
    headerHeight: 95,
    headerHeightMobile: 60,
    headerLogoContainerWidth: 225,
    headerFeedContainer: 325,
    componentTabsAltIcon: 'property-snowbird-wings',
  },
};
